















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class RegisterCaseWarnings extends Vue {
    @Prop()
    warnings!: [];

    save() {
        this.$emit("close");
        this.$emit("save");
    }
}
